import AddButton from 'components/iam/jobs/components/AddButton'
import DeleteButton from 'components/iam/jobs/components/DeleteButton'
import EditButton from 'components/iam/jobs/components/EditButton'

const ActionComponents = ({
  openCreateModal = undefined,
  openEditModal = undefined,
  openDeleteModal = undefined
}) => (
  <>
    {openEditModal && <EditButton onClick={openEditModal} />}
    {openDeleteModal && <DeleteButton onClick={openDeleteModal} />}
    {openCreateModal && <AddButton onClick={openCreateModal} />}
  </>
)

export default ActionComponents
